import Axios from "axios";

const baseURL = process.env.BARRAMUNDI;

export default {
    getDiscounts() {
        return Axios.get(`${baseURL}account/discount`).then(
            response => response.data.response
        );
    },
    getDiscount(id) {
        return Axios.get(baseURL + "account/discount/" + id).then(
            response => response.data.response
        );
    },
    saveDiscount(param) {
        return Axios.post(baseURL + "account/discount", param).then(
            response => response.data.response
        );
    },
    updateDiscount(id, param) {
        return Axios.put(baseURL + "account/discount/" + id, param).then(
            response => response.data.response
        );
    }
};
